import React from "react";
import { Link } from "react-scroll";
import { StaticImage } from "gatsby-plugin-image";
import SubScribeform from "../../components/kmc/forms/subscribeForm";

const Footer = () => {
  return (
    <>
      <footer className="footer-kmc">
        <div className="container-fluid">
          <div className="row bg-white p-3 footer-topheading">
            <div className="col-lg-6 col-sm-12 col-md-6">
              <div className="footer_logo_kmc">
                <StaticImage
                  src="../../assets/images/kmc-images/kmc-new-xd-logo.png"
                  alt="KMC Logo"
                />
              </div>
            </div>
            <div className="col-lg-6 pt-4 col-sm-12 col-md-6">
              <h2>Access Quality Health Care</h2>
            </div>
          </div>
          <div className="row pt-2 pb-4 footer-menus">
            <div className="col-lg-3 col-sm-12 col-md-6 mt-3">
              <h2>For Emergency</h2>
              <p>
                <i className="fa fa-clock-o" style={{ marginRight: "5px" }} />
                24 / 7
              </p>
              <p>
                <a href="tel:07981284023" rel="noreferrer">
                  <i className="fa fa-phone footer-Icons" /> 079812 84023
                </a>
              </p>
              <h2 className="pt-3">Schedule An Appointment</h2>
              <p>
                <i className="fa fa-clock-o" style={{ marginRight: "5px" }} />9
                AM to 5 PM Mon-Sat
                <br />
                10 AM - 1 PM Sun
              </p>
              <p>
                <a href="tel:08548249008" rel="noreferrer">
                  <i className="fa fa-phone footer-Icons" /> 085482 49008
                </a>
                <br />
                <a href="tel:09133355446 " rel="noreferrer">
                  <i className="fa fa-phone footer-Icons" />
                  091333 55446
                </a>
              </p>
              <h2 className="pt-3">Write to us</h2>
              <p>
                <a href="mailto:medical@heartfulness.org" rel="noreferrer">
                  <i className="fa fa-envelope-o footer-Icons" />{" "}
                  medical@heartfulness.org
                </a>
              </p>
            </div>
            <div className="col-lg-3 col-sm-12 col-md-6 mt-3">
              <h2>For Pharmacy</h2>
              <p>
                <i className="fa fa-clock-o" style={{ marginRight: "5px" }} />
                24 / 7
              </p>
              <p>
                <a href="tel:08639713974" rel="noreferrer">
                  <i className="fa fa-phone footer-Icons" /> 086397 13974
                </a>
              </p>
              <h2 className="pt-3">For Lab</h2>
              <p>
                <i className="fa fa-clock-o" style={{ marginRight: "5px" }} />{" "}
                7.30 am to 4 pm Mon-Sat
                <br />
                Sunday : Holiday
              </p>
              <p>
                <a href="tel:08548249032" rel="noreferrer">
                  <i className="fa fa-phone footer-Icons" /> 085482 49032
                </a>
                <br />
                <a href="tel:09666830225" rel="noreferrer">
                  <i className="fa fa-phone footer-Icons" /> 096668 30225
                </a>
              </p>
            </div>
            <div className="col-lg-3 col-sm-12 col-md-6 mt-3">
              <h2>Quick</h2>
              <ul>
                <li>
                  <Link
                    to="Building_Infrastructure"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                  >
                    Building &amp; Infrastructure
                  </Link>
                </li>
                <li>
                  <Link
                    to="Doctors_Services"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                  >
                    Doctors &amp; Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="Health_Camps"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                  >
                    Health Camps
                  </Link>
                </li>
                <li>
                  <Link
                    to="offers"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                  >
                    Offers
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="testimonials"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                  >
                    Testimonials
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="contributionskmc"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                  >
                    Contributions
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="contactUsKmc"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-sm-12 col-md-6 mt-3">
              {/* <h2>Other</h2>
              <ul>
                <li>Disclaimer</li>
                <li>Cancellation and refund policy</li>
                <li>Privacy Policy</li>
                <li>CSR Policy </li>
                <li>Terms and Conditions </li>
                <li>COVID Vaccination</li>
              </ul> */}
              <p>
                Subscribe to our newsletter to get important news about offers
                and medical camps:
              </p>
              <SubScribeform />
            </div>
          </div>
          <div
            className="row pt-5 social-links-kmc"
            style={{ display: "none" }}
          >
            <div className="col-lg-8 col-sm-12 col-md-6">
              <h2>CONNECT WITH US:</h2>
              <ul>
                <li>
                  <i className="fa fa-facebook" aria-hidden="true" />
                </li>
                <li>
                  <i className="fa fa-twitter" aria-hidden="true" />
                </li>
                <li>
                  <i className="fa fa-youtube-play" aria-hidden="true" />
                </li>
                <li>
                  <i className="fa fa-linkedin" aria-hidden="true" />
                </li>
                <li>
                  <i className="fa fa-instagram" aria-hidden="true" />
                </li>
                <li>
                  <i className="fa fa-paper-plane-o" aria-hidden="true" />
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-sm-12 col-md-6">
              <p>
                Subscribe to our newsletter to get important news about offers
                and medical camps:
              </p>
              {/* <Subscribe /> */}
            </div>
          </div>
        </div>
        <div className="footer-bottomBg py-3">
          <div className="container-fluid">
            <div className="row justify-content-center text-center">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <p>
                  © Copyright Kanha Medical Centre. All Right Reserved. Designed
                  and Developed by Heartfulness
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
